'use client'

import React from "react";

import * as S from "./Hero.styles";

import HeroPrimary from "./HeroPrimary/HeroPrimary.component";
import HeroSecondary from "./HeroSecondary/HeroSecondary.component";
import HeroTertiary from "./HeroTertiary/HeroTertiary.component";
import HeroQuaternary from "./HeroQuaternary/HeroQuaternary.component";
import HeroNews from "./HeroNews/HeroNews.component";
import HeroProfile from "./HeroProfile/HeroProfile.component";

const Hero = ({ variant, ...props}) => {

  const HeroDispatcher = {
    primary: HeroPrimary,
    secondary: HeroSecondary,
    tertiary: HeroTertiary,
    quaternary: HeroQuaternary,
    news: HeroNews,
    profile: HeroProfile
  }

  const Hero = HeroDispatcher[variant];

  return (
    <S.Hero>
      <Hero {...props} />
    </S.Hero>
  );
};

export default Hero;
